import {Response} from 'miragejs';
import {StatusCodes as HTTP} from 'http-status-codes';



export default server => {
    const db = [{
        id: 0,
        business_profile_id: 1,
        social_types: ['facebook', 'twitter'],
        languages: ['en', 'es'],
        exclude_terms: {'exclude this': 'replace with this', 'remove this': null}
    },
        {
            id: 1,
            business_profile_id: null,
            social_types: [],
            languages: [],
            exclude_terms: {'shoot': 'throw', 'war': null}
        }]

    server.get('/api/v1/sentiment', (schema, {queryParams: {business_profile_id}}) => {
        const bpId = business_profile_id;

        const displayedTerms = db.filter(id => [bpId, null].includes(id.business_profile_id))
            .map(x => Object.entries(x.exclude_terms).map(([key, value]) => ({
                textToExclude: key,
                replaceWith: value,
                languages: x.languages,
                socialTypes: x.social_types,
            }))).flat().map((x, i) => ({...x, id: i}))

        return new Response(HTTP.OK, {}, displayedTerms);
    });
};
